import React from 'react';
import styled, { css } from "styled-components";
import { CONTROL_FIELD_HEIGHT } from '../styling/theme';

interface ContainerProps {
  loading?: boolean;

}

const Container = styled.div<ContainerProps>`
  ${({ loading }) => loading && css`
    opacity: 0.5;
  `}

  button {
    height: ${CONTROL_FIELD_HEIGHT / 10}rem;
    width: 100%;
    padding: 0px 20px;
    background-color: #0d9bda;
    outline: none;
    border: none;
    color: white;
    border-radius: 3px;
    font-size: 1.6rem;
    cursor: pointer;
  }

  &.secondary button {
    background: white;
    color: #676767;
    border: 1px solid #d8d8d8;
  }

  &.danger button {
    background: #da0d0d;
  }
`;

interface OwnProps {
  text: string;
  loadingText?: string;
  loading?: boolean;
  onClick?: () => void;
}

type Props = OwnProps & React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export default function Button(props: Props) {
  const { text, loadingText, loading = false, onClick, className, ...otherProps } = props;

  const onClickHandler = () => {
    if (!loading && onClick) onClick();
  }
  return (
    <Container className={className} loading={loading} style={{ width: otherProps.style?.width }}>
      <button onClick={onClickHandler} {...otherProps}>
        {!loading && (
          <>{text}</>
        )}

        {loading && !loadingText && (
          <>{text}</>
        )}

        {loading && loadingText && (
          <>{loadingText}</>
        )}
      </button>
    </Container>
  );
}